import { render, staticRenderFns } from "./TopfiveQtd.vue?vue&type=template&id=6e991ac9&"
import script from "./TopfiveQtd.vue?vue&type=script&lang=js&"
export * from "./TopfiveQtd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports